import { enumBankAccountType } from '@enum/enumBankAccountType';
import { enumFileExtension } from '@enum/enumFileExtension';
import { enumMimeType } from '@enum/enumMimeType';
import { environment } from '@env/environment';
import { BankAccountDetailsModel } from '@interfaces/bank-account-details';
export const DEFAULT_ISF_UNIT_FOR_MULTIPLE_ISF: string = 'PCS';

export const ESTIMATED_NUMBER_OF_ENTRIES_OPTIONS: string[] = ['15 - 30', '30 - 100', '100 - 300', 'more than 300'];
export const ESTIMATED_ENTRIES_VALUE_OPTIONS: string[] = ['$1M - $2M', 'more than $2M'];

export const ACH_FORM_400_LINK: string = 'https://www.cbp.gov/document/forms/form-400-ach-application';

export const FIRST_INCOTERMS: string[] = ['FOB', 'CIF'];
/** Line item description cap (form validator + what the classification assistant writes into a line). */
export const LINE_ITEM_DESCRIPTION_MAX_LENGTH: number = 60;
export const WEIGHT_UNIT_KG: string = 'KG';
export const WEIGHT_UNIT_LB: string = 'LB';

export const SOFTWARE_PROVIDER_FILER_CODE: string = 'SY1';
export const CHINA_COUNTRY_CODE: string = 'CN';
export const CANADA_COUNTRY_CODE: string = 'CA';
export const USA_COUNTRY_CODE: string = 'US';
export const MEXICO_COUNTRY_CODE: string = 'MX';
export const INDIA_COUNTRY_CODE: string = 'IN';

export const MEXICO_COUNTRY_ID: number = 144;
export const CANADA_COUNTRY_ID: number = 40;
export const CHINA_COUNTRY_ID: number = 46;
export const USA_COUNTRY_ID: number = 236;

export const ENTERED_VALUE_TOTAL_LIMIT: number = 250.5;
export const ENTERED_VALUE_CHINA_LIMIT: number = 250.5;

export const LA_TIMEZONE_NAME: string = 'America/Los_Angeles';
export const DEFAULT_TIMEZONE_NAME: string = 'Greenwich';

export const ALLOWED_FILE_EXTENSIONS: enumFileExtension[] = [
  enumFileExtension.PDF,
  enumFileExtension.GIF,
  enumFileExtension.PNG,
  enumFileExtension.JPG,
  enumFileExtension.JPEG,
  enumFileExtension.XLS,
  enumFileExtension.XLSX,
  enumFileExtension.DOC,
  enumFileExtension.DOCX,
];
export const ALLOWED_FILE_MIMES: enumMimeType[] = [
  enumMimeType.PDF,
  enumMimeType.GIF,
  enumMimeType.PNG,
  enumMimeType.JPG,
  enumMimeType.JPEG,
  enumMimeType.XLS,
  enumMimeType.XLSX,
  enumMimeType.DOC,
  enumMimeType.DOCX,
];

export const DEFAULT_MAX_LIMIT: number = 1000;

export const DEFAULT_DISMISS_REASON: string = 'dismiss';

export const DEFAULT_MAX_MOBILE_WIDTH: number = 1199;

export const DEFAULT_NULL_GUID: string = '00000000-0000-0000-0000-000000000000';

export const LOADING_STARTED_KEY: string = 'loading_started_at';

export const OCEAN_DIM_FACTOR: number = 1;
export const CENTIMETER_METRE_RATIO: number = 0.01;
export const INCH_METRE_RATIO: number = 0.0254;
export const LB_TO_KG_RATIO: number = 2.2046;
export const KG_TO_TON_RATIO: number = 0.001;
export const METRE_CENTIMETER_RATIO: number = 100;
export const MAX_NON_STACKABLE_HEIGHT_CENTIMETRE: number = 270;
export const MAX_NON_STACKABLE_HEIGHT_INCH: number = 106.3;

// GMA Pallet
export const PALLET_GMA_METRIC_LENGTH: number = 101.6;
export const PALLET_GMA_METRIC_WIDTH: number = 121.9;
export const PALLET_GMA_IMPERIAL_LENGTH: number = 40;
export const PALLET_GMA_IMPERIAL_WIDTH: number = 48;
// EUR1 Pallet
export const PALLET_EUR_1_METRIC_LENGTH: number = 120;
export const PALLET_EUR_1_METRIC_WIDTH: number = 80;
export const PALLET_EUR_1_IMPERIAL_LENGTH: number = 47;
export const PALLET_EUR_1_IMPERIAL_WIDTH: number = 31.5;
// EUR2 Pallet
export const PALLET_EUR_2_METRIC_LENGTH: number = 120;
export const PALLET_EUR_2_METRIC_WIDTH: number = 100;
export const PALLET_EUR_2_IMPERIAL_LENGTH: number = 47;
export const PALLET_EUR_2_IMPERIAL_WIDTH: number = 39.3;

export const DEFAULT_STATUS_PING_TIME: number = 30000;

export const POA_FILE_URL: string = environment.poaFileURL;
export const IMPORT_CUSTOMS_FILE_URL: string = environment.importCustomsFileURL;

export const LCL_EXIT_INTENT_SHOWN: string = 'LCL_EXIT_INTENT_SHOWN';

export const DEFAULT_POLLING_TIMEOUT: number = 1000;
export const DEFAULT_LONGER_POLLING_TIMEOUT: number = 5000;
export const DEFAULT_MAX_POLLING_RETRY: number = 20;
export const DEFAULT_DEXIE_DB_RETRY: number = 5;

export const DEFAULT_EMPTY_RADIO: string = 'empty_value';

export const DEFAULT_BANK_WIRE_ID: number = 7; // #10512

export const DEFAULT_COMPANY_PAYMENT_SUFFIX: string = '00000';

export const DEFAULT_PAGINATION_ITEMS: number[] = [20, 50, 100];

export const BANK_ACCOUNT_DETAILS: BankAccountDetailsModel = {
  [enumBankAccountType.DELAWARE]: {
    companyName: 'Eezy Import, Inc 5036 Clark Howell Hwy, Atlanta, GA 30349, United States',
    accountNumber: '375022423219',
    routingNumber: {
      wire: '026009593',
      paperAndElectronic: '072000805',
    },
  },
};
